export const finalizeSampleUiSchema = {
  'ui:order': ['followUp', 'followUpComment'],
  followUp: {
    'ui:widget': 'radio',
    'ui:stacked': true
  },
  followUpComment: {
    'ui:widget': 'textarea',
    'ui:placeholder': 'Skriv her...',
    'ui:options': {
      rows: 5
    }
  }
}
